import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentAllDelete = {
    path: "/consent/all",
    method: RouteHttpVerb.DELETE
};
export { locationRestConsentAllDelete };
